import barba from '@barba/core';
import aos from './utils/aos'

barba.hooks.beforeEnter(({ next }) => {
	document.documentElement.className = next.container.dataset.pageClasses || ''
	document.documentElement.classList.add('scroll--top')
	aos(document)
})

barba.hooks.afterEnter( ()=>{
	document.querySelectorAll('video[autoplay]').forEach( v => v.play() )
} )

// import all transitions in the barba transitions folder
const transitions = []
const t = require.context('./transitions/', false, /\.js$/)
t.keys().forEach(key => transitions.push(t(key).default))

// import all views in the barba views folder
const views = []
const v = require.context('./views/', false, /\.js$/)
v.keys().forEach(key => views.push(v(key).default))

// initialise Barba.js
barba.init({
	transitions,
	views,
	timeout: 5000,
	debug: true
})
